import { useState, useEffect } from "react";
import Main from "../../layouts/Main";
import Card from "../../components/Card";
import MasterBonusService from "../../services/MasterBonus";
import Loader from "../../components/Loader";
import MasterBonusItem from "./MasterBonusItem";
import MasterBonusEdit from "./MasterBonusEdit";
import MasterBonusAdd from "./MasterBonusAdd";
import MasterBonusNotif from "./MasterBonusNotif";
import MasterBonusDelete from "./MasterBonusDelete";
import Button from "../../components/Button";
import { set } from "lodash";

const MasterBonus = () => {
  const [Bonus, setBonus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [data, setData] = useState(null);
  const [type, setType] = useState("");

  useEffect(() => {
    setLoading(true);

    MasterBonusService.list()
      .then((res) => {
        setBonus(res.data.data);
        setIsUpdated(false);
      })
      .catch((err) => {
        console.error(err);
        setIsUpdated(false);
      });

    setLoading(false);
  }, [isUpdated]);

  const addHandler = (data) => {
    setModalAdd(true);
    setData(data);
    setType("");
  };

  const closeModalHandler = () => {
    setModalConfirm(false);
    setModalEdit(false);
    setModalAdd(false);
    setModalDelete(false);
  };

  const getLocalStorage = (key) => {
    const localStorageData = localStorage.getItem(key);
    return localStorageData ? JSON.parse(localStorageData) : null;
  };

  const updated_by = getLocalStorage("rms") || "Unknown";

  if (loading == true) {
    return <Loader />;
  }

  return (
    <Main title="Configuration Bonus">
      {modalEdit && (
        <MasterBonusEdit
          data={data}
          activeModal={modalEdit}
          closeClick={closeModalHandler}
          setModalConfirm={setModalConfirm}
          setType={setType}
          user={updated_by}
        />
      )}

      {modalAdd && (
        <MasterBonusAdd
          data={data}
          activeModal={modalAdd}
          closeClick={closeModalHandler}
          setModalConfirm={setModalConfirm}
          setType={setType}
          user={updated_by}
        />
      )}

      {modalDelete && (
        <MasterBonusDelete
          data={data}
          activeModal={modalDelete}
          closeClick={closeModalHandler}
          setModalConfirm={setModalConfirm}
          setUpdate={setIsUpdated}
          user={updated_by}
        />
      )}

      {modalConfirm && (
        <MasterBonusNotif activeModal={modalConfirm} closeClick={closeModalHandler} setUpdate={setIsUpdated} type={type} />
      )}

      <Card col={"col-xl-12 col-lg-12"}>
        <div className="row d-flex justify-content-end p-0 m-0 gap-2 w-100 mb-4">
          <div className="p-0 m-0 w-auto">
            <Button title="Tambah Aturan Bonus" button="btn-primary btn-md" titleBold={true} onClick={addHandler} />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              <table className="table table-bordered text-nowrap text-md-nowrap text-center mb-0">
                <thead style={{ backgroundColor: "#E8E9F4" }}>
                  <tr>
                    <th>No</th>
                    <th>Minimal Kerja</th>
                    <th>Maximal Kerja</th>
                    <th>Amount</th>
                    <th>Created By</th>
                    <th>Updated By</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Bonus.length > 0 ? (
                    Bonus.map((bonus, index) => (
                      <MasterBonusItem
                        key={bonus.id || index}
                        no={index + 1}
                        data={bonus}
                        user={updated_by}
                        setModalEdit={setModalEdit}
                        setModalDelete={setModalDelete}
                        setData={setData}
                        setUpdate={setIsUpdated}
                      />
                    ))
                  ) : (
                    <tr>
                      <td colSpan="12">No Data Available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Card>
    </Main>
  );
};

export default MasterBonus;
